import { ROLES } from 'common/constants';
import { OpenGlCalendarsType } from 'pages/VendorsTablePage/components/PrintChecks/types';
import {
  checkIfPaymentDateIsSameOrAfterPostaheadStart,
  getMonthFromDate
} from './helpers';

export const getValidPostingRequirements = (
  dates: OpenGlCalendarsType,
  paymentDate: string,
  userRole: string
): boolean => {
  if (dates.glCutoffDate !== '' && userRole !== ROLES.AP_OFFICE_MANAGER) {
    if (
      getMonthFromDate(paymentDate) === getMonthFromDate(dates?.currentStart)
    ) {
      return false;
    }

    if (
      !checkIfPaymentDateIsSameOrAfterPostaheadStart(
        dates.postaheadStart,
        paymentDate
      )
    ) {
      return false;
    }
  }

  return true;
};
